// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_2e-0r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Wrappers/StopoverWrapper/StopoverWrapper.scss
// module id = 507
// module chunks = 0